// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7f861d3c","455":"8409d45f","977":"3af79f78"}[chunkId] + ".chunk.js";
};